import type { ProviderOnboardingSource } from '@/features/provider/onboarding/onboardingModel';

export type ProviderAccountProfileLike = ProviderOnboardingSource & {
  name?: string | null;
  address?: {
    line1?: string | null;
    city?: string | null;
    province?: string | null;
  } | null;
};

export { isProviderProfileComplete } from '@/features/provider/onboarding/onboardingModel';
